.cl{padding:0.5rem;}